import { render, staticRenderFns } from "./GeneratorCanvas.vue?vue&type=template&id=27a13a82&"
import script from "./GeneratorCanvas.vue?vue&type=script&lang=js&"
export * from "./GeneratorCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports